export const DOBAVLJAC_V1ResourcesEN: DOBAVLJAC_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
  input: {
    street: {
      label: "Street and number",
      name: "street",
      error: "You have not entered street",
    },
    city: {
      label: "City",
      name: "city",
      error: "You have not entered city",
    },
    zipCode: {
      label: "Postal code",
      name: "zipCode",
      error: "You have not entered postal code",
      validation: "Invalid number",
    },
    country: {
      label: "Country",
      name: "country",
      error: "You have not entered country",
    },
    phone: {
      label: "Phone",
      name: "phoneNumber",
      error: "You have not entered phone",
      validation: "Invalid number",
    },
    idCompanyNumber: {
      label: "ID number",
      name: "idTax",
      error: "You have not entered ID number",
      validation: "Invalid number",
    },
    vatCompanyNumber: {
      label: "VAT number",
      name: "vatCompanyNumber",
      error: "You have not entered VAT number",
      validation: "Invalid number",
    },
    name: {
      label: "Supplier name",
      name: "name",
      placeholder: "Please enter supplier name",
      error: "",
    },
    productType: {
      label: "Product type",
      name: "productType",
      placeholder: "Please enter product type",
      error: "",
    },
    dialogSuccess: {
      title: "Success!",
      body: "You have added the company to the database!",
      buttonOk: "OK",
    },
  },
};

interface InputField {
  label: string;
  name: string;
  error: string;
  validation?: string;
  placeholder?: string;
}

interface DialogSuccess {
  title: string;
  body: string;
  buttonOk: string;
}

interface Input {
  street: InputField;
  city: InputField;
  zipCode: InputField;
  country: InputField;
  phone: InputField;
  idCompanyNumber: InputField;
  vatCompanyNumber: InputField;
  name: InputField;
  productType: InputField;
  dialogSuccess: DialogSuccess;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DOBAVLJAC_V1ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  input: Input;
  errors: IErrors;
}
